import axios from "axios";

// Estado do cluster Slurm (serviço jobs/, via Kong). Só existe na implantação em cluster.
const cluster = axios.create({
  baseURL: process.env.VUE_APP_CLUSTER_LOCATION || "/cluster",
  timeout: 10000
});

export default cluster;
